// @flow

import { observer } from 'mobx-react';
import React, { Component } from 'react';
import classNames from 'classnames';
import { ChromePicker } from 'react-color';
import { default as RcTooltip } from 'rc-tooltip';
import onClickOutside from 'react-onclickoutside';
import './ColorPicker.scss';

type Props = {
  name: string,
  color: string,
  tooltip: string,
  setColor: Function,
  propertyName: string,
  disabled: ?boolean,
}

type State = {
  isActive: boolean
}

const ToolTipWrapper = (props) =>
  props.tooltip != undefined ?
    <RcTooltip placement="top" overlay={props.tooltip}>{props.children}</RcTooltip>
    : props.children;

@observer
class ColorPicker extends Component<Props, State> {

  constructor(props: Object) {
    super(props);
    this.state={
      isActive: false,
    };
  }

  handleClick = () => {
    if (!this.props.disabled || this.state.isActive) {
      this.setState({isActive: !this.state.isActive});
    }

  }

  handleChange = (color: Object) => {
    this.props.setColor(this.props.propertyName, color.hex);
  }

  handleClickOutside = () => {
    this.setState({isActive: false});
  };

  render() {
    const hex = this.props.color || '#ffffff';
    return (
      <ToolTipWrapper tooltip={this.props.tooltip}>
        <div
          className={classNames(
            'color-picker',
            {'disabled': this.props.disabled}
          )}
        >
          <button
            className={classNames(
              'color-box',
              this.props.propertyName + '-cls',
              {
                'active': this.state.isActive === true,
                'white': this.props.color.toLowerCase() == '#ffffff' || this.props.color.toLowerCase() == '#fff' || this.props.color == '',
              }
            )}
            onClick={this.handleClick}
            style={{backgroundColor: hex}}>
          </button>
          <ChromePicker
            className="picker"
            color={hex}
            onChange={this.handleChange}
            disabled={this.props.disabled}
            colors={['#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC', '#0693E3', '#ABB8C3', '#EB144C', '#F78DA7', '#9900EF', '#000000', '#FFFFFF']}
          />
          <div className="color-info">
            <p className="name">{this.props.name}</p>
            <p className="hex">{hex}</p>
          </div>
        </div>
      </ToolTipWrapper>
    );
  }
}

export default onClickOutside(ColorPicker);
